<template>
  <section class="enwoke-news">
    <h4 class="section-title">News</h4>
    <div class="news-list" v-if="news">
      <div class="news-item" v-for="(newData, index) in news.results" :key="index">
        <div class="created-at">{{dateFormat(newData.createdAt)}}</div>
        <div class="thumbnail" v-if="newData.mainImageUrl">
          <img :src="newData.mainImageUrl" />
        </div>
        <div class="description" v-html="newData.content"></div>
      </div>
    </div>
  </section>
</template>

<script>
import dummy from "@/assets/images/dummy-news-1.jpg";
import moment from "moment";
export default {
  data() {
    return {
      images: {
        dummy,
	  },
	  news: []
    };
  },
  mounted() {
	  this.loadNews();
  },
  methods: {
    async loadNews() {
	    this.news = await this.$repo.news.getNews();
    },
    dateFormat(createdAt) {
      return moment(createdAt).format('MMMM Do YYYY, h:mm:ss a')
    }
  },
};
</script>

<style lang="scss" scoped>
.enwoke-news {
  .news-list {
    background-color: #fff;
    padding: 30px;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
  }

  .news-item {
    .created-at {
      font-size: 10px;
      margin: 0 0 1em;
    }
    .thumbnail {
      width: 100%;
      margin-bottom: 20px;

      img {
        width: 100%;
        height: auto;
      }
    }

    .description {
      font-size: 14px;
    }
  }

  .news-item + .news-item {
    margin-top: 24px;
  }
}
</style>
